<template>
  <v-dialog v-model="dialog" max-width="1100">
    <v-card>
      <v-card-title class="headline">AGREGAR COMPROBANTES</v-card-title>
      <v-card-text>
        <p>Ingresa la clave de acceso de tus facturas para el pago de la liquidación</p>
        <v-container>
          <v-row v-for="(item, index) in items" :key="index" align="center" class="d-flex align-center mb-2 row-border">
            <v-col cols="12" sm="3">
              <v-text-field label="Clave" v-model="item.clave" outlined dense class="field-border" type="number"
                :rules="claveRules" @input="sanitizeInput(item, 'clave')" maxlength="49"
                :disabled="item.disabled"></v-text-field>
            </v-col>
            <v-col cols="3" sm="2">
              <v-text-field label="Subtotal 15%" v-model="item.subtotal15" outlined dense readonly
                class="field-border"></v-text-field>
            </v-col>
            <v-col cols="3" sm="2">
              <v-text-field label="Subtotal 0%" v-model="item.subtotal0" outlined dense readonly
                class="field-border"></v-text-field>
            </v-col>
            <v-col cols="3" sm="2">
              <v-text-field label="IVA" v-model="item.iva" outlined dense readonly class="field-border"></v-text-field>
            </v-col>
            <v-col cols="3" sm="2">
              <v-text-field label="Total" v-model="item.total" outlined dense readonly
                class="field-border"></v-text-field>
            </v-col>

          </v-row>
        </v-container>


        <!-- Botón Consultar centrado debajo de las filas -->
        <v-container class="text-center mt-3">
          <v-btn color="primary" @click="consultar" :disabled="consultarDisabled">CONSULTAR</v-btn>
          <v-btn color="primary" @click="resetValues">LIMPIAR</v-btn>
        </v-container>
      </v-card-text>
      <v-row>
        <v-col cols="9">
          <!-- Mensaje de éxito o error alineado a la izquierda -->
          <div v-if="successMessage && alertMessageShow" class="success-message">
            {{ alertMenssageSuccessText }}
          </div>
          <div style="width: 74%;" v-if="!successMessage && alertMessageShow" class="error-message">
            {{ alertMenssageText }}
          </div>
        </v-col>

        <v-col cols="3" class="d-flex justify-end">
          <!-- Botones Guardar y Cerrar alineados a la derecha -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="confirmGuardar" :disabled="guardarDisabled">
              <template v-if="guardarBusy">
                <v-progress-circular indeterminate size="18" width="2" class="mr-2"></v-progress-circular>
                Guardando…
              </template>
              <template v-else>
                GUARDAR
              </template>
            </v-btn>
            <v-btn outlined @click="closeDialog">CERRAR</v-btn>
          </v-card-actions>
        </v-col>
      </v-row>

    </v-card>

    <!-- Confirmación al guardar -->
    <v-dialog v-model="confirmDialog" max-width="400">
      <v-card>
        <v-card-title class="headline text-center">
          ¿DESEA INGRESAR UNA CLAVE DE ACCESO ADICIONAL?
        </v-card-title>
        <v-card-actions class="justify-center">
          <v-btn color="primary" @click="agregarClave">SÍ</v-btn>
          <v-btn outlined @click="closeAlert">NO</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import serviceFactura from '@/services/FacturaServices';
export default {
  name: 'FacturarDialogProduction',
  props: {
    show: Boolean,
    totalIncome: Number,
    numberLiquidation: Number
  },
  data() {
    return {
      dialog: false,
      confirmDialog: false,
      alertMenssageText: '',
      alertMessageShow: false,
      valorFacturasConsultas: 0,
      alertMenssageSuccessText: '',
      consultarDisabled: false,
      guardarDisabled: false,
       guardarBusy: false,      
    _keydownHandlerG: null,   
      items: [
        {
          clave: '',
          subtotal15: '',
          subtotal0: '',
          iva: '',
          total: '',
        },
      ],
      successMessage: false,
      // Reglas de validación para la clave
      claveRules: [
        (v) => !!v || 'Clave es requerida',
        (v) => v.length <= 49 || 'Máximo 49 caracteres permitidos',
        (v) => /^[0-9]+$/.test(v) || 'Solo se permiten números',
      ],
    };
  },
  watch: {
    show(val) {
      this.dialog = val;
      if (val) {
        //this.resetValues(); // Llama a la función para restablecer valores
      }
    },
    dialog(val) {
      if (!val) {
        this.$emit('close');  // Emite el evento de cierre cuando se cierra el diálogo
      }
    },
  },
  mounted() {
  this._keydownHandlerG = (evt) => {
    if (this.guardarBusy && evt.key === 'Enter') {
      evt.preventDefault();
      evt.stopPropagation();
    }
  };
  document.addEventListener('keydown', this._keydownHandlerG, true);
},
beforeDestroy() { // (en Vue 3 usa beforeUnmount)
  document.removeEventListener('keydown', this._keydownHandlerG, true);
  this._keydownHandlerG = null;
},
  computed: {
    ...mapGetters(["userProfile", "agencyId"])
  },
  methods: {
    consultarDatosSri() {
      this.$root.$emit(
        "showLoading",
        "Cargando información, por favor espere..."
      );
      for (let i = 0; i < this.items.length; i++) {

        serviceFactura.GetInvoice(this.items[i].clave).then((response) => {

          if (response.data.Msg == "Ok") {
            var info = response.data.Data;

            this.items[i].subtotal15 = info.Subtotal15;
            this.items[i].subtotal0 = info.Subtotal0;
            this.items[i].iva = info.ValorIva;
            this.items[i].total = info.TotalFactura;
            this.items[i].disabled = true;
            this.$root.$emit("hideLoading");
            this.valorFacturasConsultas = this.valorFacturasConsultas + info.TotalFactura

            this.alertMessageShow = false;
          } else {

            this.successMessage = false;
            this.alertMessageShow = true;
            this.$root.$emit("hideLoading");



          }

        }).catch(() => {
          this.successMessage = false;
          this.alertMessageShow = true;
          this.$root.$emit("hideLoading");
          this.alertMenssageText = 'Existe un error al consultar el servicio de Facturas';
        }).finally(() => {
          this.validarTotal();
          this.$root.$emit("hideLoading");

        })
      }


    },
    sanitizeInput(item, field) {
      item[field] = item[field].replace(/\s/g, '').replace(/[^0-9]/g, '');  // Eliminar espacios y caracteres no numéricos
    },
    closeDialog() {
      this.resetValues();
      this.dialog = false;

    },
    closeAlert() {
      this.confirmDialog = false
      this.consultarDatosSri();
      this.consultarDisabled = true;

    },
    confirmGuardar() {
  // Anti doble clic: si ya está deshabilitado, no hagas nada
  if (this.guardarDisabled) return;

  // Marca busy (spinner) y deshabilita botón para evitar reintentos
  this.guardarBusy = true;
  this.guardarDisabled = true;

  // Spinner global existente
  this.$root.$emit("showLoading", "Cargando información, por favor espere...");

  // Bloquear Enter solo durante el guardado (se limpia en finally)
  const keydownHandler = (evt) => {
    if (evt.key === 'Enter') {
      evt.preventDefault();
      evt.stopPropagation();
    }
  };
  document.addEventListener('keydown', keydownHandler, true);

  const model = {
    "ItemPeople": this.items,
    "NumeroLiquidacion": this.numberLiquidation || "0",
    "Tipo": 1,
    "IdAps": this.userProfile.user_id,
    "Agencia": this.agencyId
  };

  serviceFactura.ingresoFactura(model)
    .then(() => {
      // Éxito: mantener deshabilitado (no permitir reenvío)
      this.confirmDialog = false;
      this.successMessage = true;
      this.alertMessageShow = true;
      this.alertMenssageSuccessText = 'Se ha guardado correctamente.';
      this.guardarBusy = false; // quita spinner (botón queda deshabilitado)
    })
    .catch((error) => {
      // Error: mostrar mensaje claro y permitir reintento
      this.alertMessageShow = true;
      this.successMessage = false;

      let msg = 'Ocurrió un error al ingresar.';
      if (error && error.response && error.response.data && Array.isArray(error.response.data.Errors) && error.response.data.Errors.length > 0) {
        msg = error.response.data.Errors[0];
      } else if (error && error.response && error.response.status === 409) {
        msg = 'La operación ya fue registrada o existe un duplicado.';
      } else if (error && error.response && error.response.status === 400) {
        msg = 'Datos inválidos. Verifica la información antes de guardar.';
      } else if (error && error.response && error.response.status === 500) {
        msg = 'Error interno del servidor. Inténtalo nuevamente.';
      }
      this.alertMenssageText = msg;

      // re-habilitar solo en error
      this.guardarBusy = false;
      this.guardarDisabled = false;
    })
    .finally(() => {
      this.$root.$emit("hideLoading");
      document.removeEventListener('keydown', keydownHandler, true);
    });
},
    agregarClave() {
      if (this.items.length < 2) {
        this.items.push({
          clave: '',
          subtotal15: '',
          subtotal0: '',
          iva: '',
          total: '',
        });
      }
      this.confirmDialog = false;
    },
    resetValues() {
      this.valorFacturasConsultas = 0,
        this.items = [
          {
            clave: '',
            subtotal15: '',
            subtotal0: '',
            iva: '',
            total: '',
          },
        ];
      this.successMessage = false;
      this.alertMessageShow = false;
      this.consultarDisabled = false;
    },
    consultar() {
      if (this.items[0].clave == '' || (this.items[1] && this.items[1].clave === '')) {
        this.confirmDialog = true;
        this.alertMessageShow = true;
        this.successMessage = false;
        this.alertMenssageText = 'La clave de acceso no puede estar vacia';
        this.confirmDialog = false;

      } else {
        if (this.items.length === 2) {
          this.confirmDialog = false;
          this.consultarDatosSri();
          this.consultarDisabled = true;

        }
        else {
          this.confirmDialog = true;
        }



      }


    },
    validarTotal() {
      if (Math.abs(this.valorFacturasConsultas - this.totalIncome) > 0.10) //0.10)
      {
        this.alertMenssageText = 'Total liquidación no coincide con el valor total factura registrada.';
        this.successMessage = false;
        this.alertMessageShow = true;
        this.confirmDialog = false;
        this.guardarDisabled = true;

      }
      else {
        this.successMessage = true;
        this.alertMessageShow = true;
        this.alertMenssageSuccessText = 'Total liquidación coincide con el valor total factura registrada.';
        this.guardarDisabled = false;

      }

    },
  }
};
</script>


<style scoped>
.headline {
  text-align: center;
}

.d-flex {
  display: flex;
  flex-direction: row;
}

.row-border {
  border: 1px solid #ccc;
  padding: 15px;
  margin-bottom: 2px;
}

.field-border {
  padding: 2px;
}

.text-center {
  display: flex;
  justify-content: center;
}

.mt-3 {
  margin-top: 16px;
}

.success-message {
  color: green;
  position: absolute;
  bottom: 16px;
  /* Ajusta según sea necesario */
  left: 16px;
  /* Cambia a right: 16px; para la esquina inferior derecha */
  background: #e7f9e7;
  /* Fondo opcional */
  padding: 8px;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

/* Estilos para el mensaje de error */
.error-message {
  color: red;
  position: absolute;
  bottom: 16px;
  /* Ajusta según sea necesario */
  left: 16px;
  /* Cambia a right: 16px; para la esquina inferior derecha */
  background: #f9e7e7;
  /* Fondo opcional */
  padding: 8px;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.loading-overlay {
  position: absolute;
  /* Establecer posición absoluta */
  z-index: 2000 !important;
  /* Asegúrate de que el z-index sea mayor */
  background-color: rgba(255, 255, 255, 0.8);
  /* Fondo semi-transparente */
  width: auto;
  /* Asegúrate de que ocupe todo el espacio */
  height: auto;
  /* Asegúrate de que ocupe todo el espacio */
  padding-left: 50%;
}
</style>
